#import "../fragments/edition-stub-fragment.graphql"

mutation CreateEdition($edition: EditionCreateInput!) {
    editionCreate(input: $edition) {
        edition {
            ...EditionStubFragment
        }
    }
}
